import { doAction, doResponseAction } from ".";

const GET_SESSION_TIMEOUT = "GET_SESSION_TIMEOUT";
const GET_SESSION_TIMEOUT_SUCCESS = "GET_SESSION_TIMEOUT_SUCCESS";
const GET_SESSION_TIMEOUT_FAILURE = "GET_SESSION_TIMEOUT_FAILURE";
const UPDATE_SESSION_TIMEOUT = "UPDATE_SESSION_TIMEOUT";
const UPDATE_SESSION_TIMEOUT_SUCCESS = "UPDATE_SESSION_TIMEOUT_SUCCESS";
const UPDATE_SESSION_TIMEOUT_FAILURE = "UPDATE_SESSION_TIMEOUT_FAILURE";

export {
  GET_SESSION_TIMEOUT,
  GET_SESSION_TIMEOUT_SUCCESS,
  GET_SESSION_TIMEOUT_FAILURE,
  UPDATE_SESSION_TIMEOUT,
  UPDATE_SESSION_TIMEOUT_SUCCESS,
  UPDATE_SESSION_TIMEOUT_FAILURE,
};

export const getSessionTimeoutAction = (callback) =>
  doAction(GET_SESSION_TIMEOUT, {}, callback);
export const getSessionTimeoutSuccessAction = (data) =>
  doResponseAction(GET_SESSION_TIMEOUT_SUCCESS, data);
export const getSessionTimeoutFailureAction = (data) =>
  doResponseAction(GET_SESSION_TIMEOUT_FAILURE, data);

export const updateSessionTimeoutAction = (params, callback) =>
  doAction(UPDATE_SESSION_TIMEOUT, params, callback);
export const updateSessionTimeoutSuccessAction = (data) =>
  doResponseAction(UPDATE_SESSION_TIMEOUT_SUCCESS, data);
export const updateSessionTimeoutFailureAction = (data) =>
  doResponseAction(UPDATE_SESSION_TIMEOUT_FAILURE, data);
